<template>
  <!-- 盘点单弹窗 -->
  <div>
    <BaseDialog title="新增退库单" @handleShow="(val) => {tkDialog = val }" :isshow="tkDialog" width="1000px" height="auto">
      <div class="addform" style="margin-top:10px;">
        <div class="tables-left">
          <div class="display_flex">
            <!-- <el-form :inline="true" :model="formData">
              <el-form-item>
                <el-input class="w-208" @input="searchInput" @clear="closeDrugList" v-model="formData.searchs"
                  @keydown.enter="search" clearable placeholder="名称/拼音">
                </el-input>
              </el-form-item>
            </el-form> -->
            <div class="info">入库单号：{{ruleForm.order_no}}</div>
            <div class="info">供货单位：{{ruleForm.supplier}}</div>
          </div>
          <!-- <div v-if="showYaoList" class="scheme-cont" v-loading="contLoading">
            <div class="display_flex">
              <div></div>
              <div class="iconSet" @click="closeDrugList"><el-icon>
                  <Close />
                </el-icon></div>
            </div>
            <div class="drug-list">
              <el-scrollbar ref="schemeRef" id="resultScroll">
                <el-table @row-click="addList" v-loading="dataListLoading" :data="tableData" size="small" stripe border
                max-height="250px" width="100%">
                  <el-table-column property="drug.name" label="名称" />
                  <el-table-column label="规格" property="drug.medi_spec" />
                  <el-table-column property="drug.min_package_unit_name" label="单位" width="60"/>
                  <el-table-column property="drug.sell_price" label="价格" width="60"/>
                  <el-table-column property="drug.company" label="厂商" />
                </el-table>
              </el-scrollbar>
            </div>
          </div> -->
        </div>
        <div class="tip">可选药品</div>
        <el-table @selection-change="handleSelectionChange" v-loading="dataListLoading" :data="tableData" size="small"
          stripe border max-height="400" :row-class-name="tableRowClassName">
          <el-table-column type="selection" align="center" width="42" />
          <el-table-column width="200" prop="name" label="名称" show-overflow-tooltip>
            <template #default="scope">
              <span>{{ scope.row.drug.name }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" property="drug.medi_spec" label="规格" show-overflow-tooltip />
          <el-table-column width="150" prop="order_no" label="入库单号" />
          <el-table-column width="120" prop="batch_no" label="批号" show-overflow-tooltip />
          <el-table-column width="150" property="drug.company" label="厂家" show-overflow-tooltip />
          <el-table-column width="110" prop="validity_end_time" align="center" label="有效期" show-overflow-tooltip />

          <!-- 入库单价 -->
          <el-table-column label="采购价" width="100">
            <template #default="scope">
              <span>{{ scope.row.buy_price }}元/{{ scope.row.drug.min_package_unit_name }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100" label="零售价">
            <template #default="scope">
              <span>{{ scope.row.price }}元/{{ scope.row.drug.dict_first_unit_name }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" label="库存数量">
            <template #default="scope">
              <el-tag effect="dark">
                {{ scope.row.store_num }} {{ scope.row.drug.min_package_unit_name }}
                <template v-if="scope.row.store_sub_num">{{ scope.row.store_sub_num }} {{
                  scope.row.drug.min_unit_name }}</template>
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column fixed="right" label="操作" align="center" width="100">
            <template #default="scope">
              <el-popconfirm title="删除后无法撤销，确认删除吗 ?" @confirm="stockDelete(scope.row,scope.$index)">
                <template #reference>
                  <el-link type="danger">删除</el-link>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="tip">所选药品</div>
        <el-table v-loading="dataListLoading" :data="tableDataRight" size="small" stripe border max-height="400">
          <el-table-column width="200" prop="name" label="名称" show-overflow-tooltip>
            <template #default="scope">
              <span>{{ scope.row.drug.name }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" label="库存数量">
            <template #default="scope">
              <el-tag effect="dark">
                {{ scope.row.store_num }} {{ scope.row.drug.min_package_unit_name }}
                <template v-if="scope.row.store_sub_num">{{ scope.row.store_sub_num }} {{
                  scope.row.drug.min_unit_name }}</template>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column width="200" :label="'退库数量'">
            <template #default="scope">
              <el-row>
                <el-col :span="12">
                  <el-input type="number" v-model="scope.row.backoff_num" :min="0" size="small">
                    <template #append>{{ scope.row.drug.min_package_unit_name }}</template>
                  </el-input>
                </el-col>
                <el-col :span="12">
                  <el-input type="number" v-model="scope.row.backoff_sub_num" :min="0" size="small">
                    <template #append>{{ scope.row.drug.min_unit_name }}</template>
                  </el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column width="150" label="退库总价(采购)">
            <template #default="scope">
              <span
                v-if="scope.row.backoff_num > 0 && scope.row.buy_price > 0 || scope.row.backoff_sub_num > 0 && scope.row.buy_price > 0">
                {{ (scope.row.buy_price * scope.row.backoff_num + scope.row.buy_price *
                scope.row.backoff_sub_num
                / scope.row.drug.min_package_num).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" property="drug.medi_spec" label="规格" show-overflow-tooltip />
          <el-table-column width="150" prop="order_no" label="入库单号" />
          <el-table-column width="120" prop="batch_no" label="批号" show-overflow-tooltip />
          <el-table-column width="150" property="drug.company" label="厂家" show-overflow-tooltip />
          <el-table-column width="110" prop="validity_end_time" align="center" label="有效期" show-overflow-tooltip />

          <!-- 入库单价 -->
          <el-table-column label="采购价" width="100">
            <template #default="scope">
              <span>{{ scope.row.buy_price }}元/{{ scope.row.drug.min_package_unit_name }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100" label="零售价">
            <template #default="scope">
              <span>{{ scope.row.price }}元/{{ scope.row.drug.dict_first_unit_name }}</span>
            </template>
          </el-table-column>


          <!-- <el-table-column fixed="right" label="操作" align="center" width="100">
            <template #default="scope">
              <el-popconfirm title="删除后无法撤销，确认删除吗 ?" @confirm="stockDelete(scope.row,scope.$index)">
                <template #reference>
                  <el-link type="danger">删除</el-link>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-row>
            <el-col span="12">
              <div class="display_flex_start">
                <span class="title">备注：</span>
                <el-input v-model="ruleForm.remark" clearable type="textarea" :rows="2" placeholder="请输入内容">
                </el-input>
              </div>
            </el-col>
          </el-row>

          <div class="tooltips display_flex_betton">
            <div class=" tooltips"><el-button style="float: left;margin-right: 20px;" type="primary"
                @click="getTotal">计算总额</el-button>退库总额小计：采购价：{{totalCGJ.toFixed(2)}}元，零售价{{totalLSJ.toFixed(2)}}元</div>
            <div style="text-align: right">
              <el-button type="primary" @click="handle()" :loading="saveLoad">完成</el-button>
              <el-button @click="cancel">取消</el-button>
            </div>
          </div>

        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<script setup>
  import {
    reactive,
    ref,
    onMounted,
    defineExpose,
    defineEmits,
    nextTick,
  } from 'vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { ElMessage } from 'element-plus'

  import { gitDictList, Antishake, TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
  const tkDialog = ref(false)
  const dictCatalogType = ref('')
  const formData = ref({
    searchs: ''
  })
  const selectTable = ref([])
  const showYaoList = ref(false)
  const tableData = ref([])
  const ruleForm = ref('')
  const pageData = ref({
    currentPage: 1,
    pageSize: 10,
    totalSum: 0,
  })
  const saveLoad = ref(false)
  const tableDataRight = ref([])
  const totalCGJ = ref(0)
  const totalLSJ = ref(0)
  onMounted(() => {

  })
  const initData = (data) => {
    tkDialog.value = true
    ruleForm.value = { ...data }
    tableData.value = []
    tableDataRight.value = []
    totalCGJ.value = 0
    totalLSJ.value = 0
    dictCatalogType.value = data.dictCatalogType
    // closeDrugList()
    search()
  }
  const tableDatas = ref([])
  // 获取列表
  const RKLBCGetInfo = async () => {
    showYaoList.value = true
    let data = {
      current: 1,
      size: 20,
      order_no: ruleForm.value.order_no,
      drug_name: formData.value.searchs,
      dict_catalog_type: dictCatalogType.value,
    }
    let res = await service.post('/api/backoff/getListRecordByOrderNo', data)
    if (res.code === 0) {
      tableData.value = JSON.parse(JSON.stringify(res.data.records))
      tableData.value.forEach(ite => {
        ite.backoff_num = 0
        ite.backoff_sub_num = 0
      })
    }
  }
  const closeDrugList = () => {
    formData.value.searchs = ''
    showYaoList.value = false
  }
  // 搜索
  const search = () => {
    // 入库列表点击之后获取药品信息
    RKLBCGetInfo()
  }

  // 复选框
  function handleSelectionChange(e) {
    console.log(e)
    tableDataRight.value = e
    // tableDatas.value = JSON.parse(JSON.stringify(tableData.value))
    // if (e.length > 0) {
    //   e.forEach(item => {
    //     tableDatas.value = tableDatas.value.map(opts => {
    //       if (opts.id == item.id) {
    //         opts.checkData = true
    //       }
    //       return opts
    //     })
    //   })
    // }
    // console.log(tableDatas.value)
    // nextTick(()=>{
    //   tableData.value = tableDatas.value
    // })
  }
  const tableRowClassName = ({ row, rowIndex }) => {
    if (row.checkData == true) {
      return 'danger-row'
    }
    return ''
  }
  //添加到右侧列表数据
  const addList = (row) => {
    closeDrugList()
    let param = {
      drug_id: row.drug.id,
      name: row.name,
      backoff_num: 0,
      backoff_sub_num: 0,
      ...row,
      record_order_id: ruleForm.value.id
    }
    if (tableDataRight.value.length == 0) {
      tableDataRight.value.push(param)
    } else {
      if (!(tableDataRight.value.some((item) => item.order_no == param.order_no && item.batch_no == param.batch_no))) {
        tableDataRight.value.push(param);
      } else {
        return ElMessage.error('不能添加重复的药品！')
      }
    }
    // tableDataRight.value.push(param)
  }
  //取消
  const cancel = async () => {
    let data = {
      order_no: ruleForm.value.order_no
    }
    let res = await service.post('/api/backoff/unlockEnterOrder', data)
    if (res.code === 0) {
      tkDialog.value = false
      ruleForm.value = {}
      tableDataRight.value = []
    }
  }
  const em = defineEmits(['refreshDataList'])
  const handle = async () => {
    if (tableDataRight.value.length <= 0) {
      ElMessage.error('请选择药品!')
      return
    }
    saveLoad.value = true
    let data = {
      dict_catalog_type: dictCatalogType.value,
      remark: ruleForm.value.remark,
      items: tableDataRight.value,
      record_order_id: ruleForm.value.id,
      record_order_no: ruleForm.value.record_order,
    }
    let res = await service.post('/api/backoff/addbackofforder', data)
    if (res.code >= 0) {
      saveLoad.value = false
      tkDialog.value = false
      ruleForm.value = {}
      tableDataRight.value = []
      em('refreshDataList')
    }else{
      saveLoad.value = false
    }
  }
  //删除
  const stockDelete = (row, index) => {
    tableDataRight.value.splice(index, 1)
  }
  const searchInput = () => {
    Antishake(search(), 2000)
  }
  const getTotal = () => {
    console.log(tableDataRight.value)
    tableDataRight.value.forEach(item => {
      if (item.backoff_num > 0 && item.buy_price > 0 || item.backoff_sub_num > 0 && item.buy_price > 0) {
        item.cgjze = (item.buy_price * item.backoff_num + item.buy_price *
          item.backoff_sub_num
          / item.drug.min_package_num).toFixed(2)
      }
      if (item.drug.min_package_num) {
        if (item.drug.dict_first_unit == item.drug.min_package_unit) {
          item.lsjze = (Number(item.price) * Number(item.backoff_num) + Number(item.price) *
            Number(item.backoff_sub_num) / Number(item.drug.min_package_num)).toFixed(2)

        } else {
          item.lsjze = ((Number(item.backoff_num) * Number(item.drug.min_package_num) +
            Number(item.backoff_sub_num)) * Number(item.price)).toFixed(2)
        }
      }
    })
    const values = tableDataRight.value.map(ite => Number(ite.cgjze));
    if (!values.every(value => isNaN(value))) {
      totalCGJ.value = values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);

    } else {
      totalCGJ.value = 0;
    }
    const valueLS = tableDataRight.value.map(ite => Number(ite.lsjze));
    if (!valueLS.every(value => isNaN(value))) {
      totalLSJ.value = valueLS.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);

    } else {
      totalLSJ.value = 0;
    }
  }
  defineExpose({
    initData,
    cancel,
    handle
  })
</script>

<style scoped lang="scss">
  .tip {
    margin: 10px 0;
  }

  .consumables-search {
    margin-top: 16px;

  }

  .display_flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .display_flex_betton {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .info {
    font-size: 14px;
    color: #333;
    padding: 0 20px;
    margin-bottom: 18px;
  }

  .display_flex_start {
    display: flex;
    justify-content: flex-start;
    align-items: self-start;
  }

  .title {
    width: 100px;
    text-align: left;
    font-size: 14px;
    color: #333;
  }

  .iconSet {
    padding: 0 10px;
    font-size: 24px;
  }

  .tooltips {
    margin: 10px 0;
    height: 50px;
    display: flex;
    align-items: center;
    font-weight: 700;
    background-color: #eaf0f7 !important;
    color: #3166ae;
    text-align: left;
    line-height: 50px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .scheme-cont {
    border: 1px solid #ccc;
    position: fixed;
    width: 80%;
    z-index: 99999999;
    background: #fff;

    .drug-list {
      width: 100%;
    }

    .item {
      height: 32px;
      line-height: 32px;
      width: 100%;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Medium';
      color: #444444;
      padding-right: 14px;
      margin-bottom: 12px;

      .lable {
        background-color: #ffffff;
        border-radius: 4px;
        padding-left: 20px;
        cursor: pointer;
      }

      &.active {
        border-right: 4px solid #3166ae;

        .lable {
          background-color: rgba(49, 102, 174, 0.3);
          color: #3166ae;
        }
      }

      &:hover {
        .lable {
          background-color: rgba(49, 102, 174, 0.3);
          color: #3166ae;
        }
      }
    }
  }
</style>